import { Base } from "./base";

export class Province extends Base {
  /**
   * @description List Province API function
   * @returns {Promise<Response>}
   */
  list(query) {
    let queryParam = new URLSearchParams(query).toString();
    const url = this._getFullURL("/cmms/province?" + queryParam);
    return this._secureFetch(url);
  }

  /**
   * @description Create Province API function
   * @returns {Promise<Response>}
   */
  create(payload) {
    const url = this._getFullURL("/cmms/province");
    return fetch(url, this._generateRequestBody({ payload, method: "POST" }));
  }

  update(id, payload) {
    const url = this._getFullURL("/cmms/province/" + id);
    return fetch(url, this._generateRequestBody({ payload, method: "PUT" }));
  }

  delete = (id) => {
    const url = this._getFullURL(`/cmms/province/${id}`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload: null,
        method: "DELETE",
      })
    );
  };
}
